





























































































































import { computed, defineComponent, ref, useContext, useRouter, watch } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import { customerPasswordRegExp, invalidPasswordMsg } from '~/modules/customer/helpers/passwordValidation';
import { RegisterFormFields } from './types';
import TextInput from '~/components/Inputs/Text.vue';
import { EMAIL_PATTERN, NAMES_PATTERN } from '~/utils/constants/code';
import { SfRadio } from '@storefront-ui/vue';
import axios from 'axios';
import { DU_STORE_CODE } from '~/utils/constants/store';
import { duHostUsers, usersDUEndpoints } from '~/utils/constants/hosts';
import { trackRegistration } from '~/helpers/trackings/24orepro/user';
import { useConfig } from '~/composables';
import InformativaSintetica from '~/components/solepro/Consensi/InformativaSintetica.vue';

export default defineComponent({
  components: {
    TextInput,
    SfRadio,
    InformativaSintetica
  },
  props: {
    form: {
      type: Object as PropType<RegisterFormFields>,
      required: true,
    }
  },
  watch: {
    isLoading(newVal) {
      const $t = this as any; //vs code lint trick
      $t.$emit('isLoading', newVal)
    }
  },
  setup(props) {
    const isLoading = ref(false);
    const { config: storeConfig } = useConfig();
    // @ts-ignore
    const { $recaptcha, $config } = useContext();
    const isRecaptchaEnabled = ref(
      typeof $recaptcha !== 'undefined' && $config.isRecaptcha,
    );
    const formCopy = ref<RegisterFormFields>();
    const registrationError = ref<string | null>(null);
    watch(() => props.form, (newForm) => { formCopy.value = { ...newForm }; }, { immediate: true, deep: true });
    const routes = useRouter();
    const RURL = routes.options.routes.find(el => el.name == 'home___24orepro').path;

    const isFormValid = computed(() => {
      const c = formCopy.value;
      return !!(
        c &&
        c.firstName && NAMES_PATTERN.test(c.firstName) &&
        c.lastName && NAMES_PATTERN.test(c.lastName) &&
        c.email && EMAIL_PATTERN.test(c.email) &&
        c.password && customerPasswordRegExp.test(c.password) &&
        c.consensoMail !== null &&
        c.consensoProfilazione !== null &&
        c.consensoSocieta !== null
      );
    })
    const openConsensoMail = ref(false)
    const openConsensoProfilazione = ref(false)
    const openConsensoSocieta = ref(false)

    return {
      formCopy,
      RURL,
      EMAIL_PATTERN,
      NAMES_PATTERN,
      registrationError,
      returnURL: process.client ? `${location.origin}${location.pathname}` : '',
      duHostUsers,
      isLoading,
      isFormValid,
      invalidPasswordMsg,
      customerPasswordRegExp,
      email: storeConfig.value.general_contact_email,
      isRecaptchaEnabled,
      $recaptcha,
      recaptchaToken: '',
      openConsensoMail,
      openConsensoProfilazione,
      openConsensoSocieta,
      
    };
  },
  methods: {

    async startRegistration() {
      const $t = this as any; //vs code lint trick
      $t.isLoading = true;
      $t.registrationError = null;

      const { data, status } = await axios.post('/sole-api/user/register', {
        ...$t.formCopy,
        siteCode: DU_STORE_CODE,
        rurl: process.client ? window.location.href : ''
      });
      if (!!data.error) {
        $t.registrationError = data.code;
        $t.isLoading = false;
        if (data.code == 'USED_EMAIL') {
          //scroll to input email
          const emailInput = $t.$el.querySelector('#registration-email');
          if (emailInput) {
            emailInput.scrollIntoView({ behavior: "smooth", block: "center" });
            (emailInput as HTMLInputElement).focus();
          }
        }
      } else {
        // set trackings and redirect to userIdentity with RURL
        trackRegistration(() => window.location.href = `${usersDUEndpoints.userLoginSSOASPX}?userIdentity=${encodeURIComponent(
          data.result.res
        )}&RURL=${window.location.origin + $t.RURL}`);
      }
    }
  }
});
